import axios from "axios";

async function getConfig() {
  const config = await axios.get(process.env.VUE_APP_CONFIG_FILE_PATH);

  return config;
}

async function getCommonConfig() {
  const commonConfig = await axios.get(
    `${
      process.env.VUE_APP_COMMON_CONFIG_FILE_PATH
    }?timestamp=${new Date().getTime()}`,
    {
      headers: { "Cache-Control": "no-cache" }
    }
  );
  return commonConfig;
}

export default {
  getConfig,
  getCommonConfig
};
